import React from 'react';
import { Button } from './ui/button';
import { MessageCircle, Phone } from 'lucide-react';
import { mockData } from '../mock';

export const HeroSection = () => {
  const handleWhatsApp = () => {
    const phoneNumber = mockData.contact.whatsapp;
    const message = encodeURIComponent('Hola, me gustaría solicitar una reparación');
    const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;
    
    const newWindow = window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
    if (!newWindow) {
      const link = document.createElement('a');
      link.href = whatsappUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };

  const handleContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="inicio"
      className="relative min-h-screen flex items-center justify-center py-20 px-4"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 69, 52, 0.7), rgba(22, 163, 74, 0.6)), url('https://images.unsplash.com/photo-1594771804886-a933bb2d609b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxhZ3JpY3VsdHVyYWwlMjBtYWNoaW5lcnl8ZW58MHx8fHwxNzU3NTQwOTIyfDA&ixlib=rb-4.1.0&q=85')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="container mx-auto text-center text-white relative z-10">
        <div className="max-w-4xl mx-auto space-y-8">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold leading-tight">
            Mantenimiento y reparación de 
            <span className="text-[#f97316] block mt-2">
              maquinaria agrícola y de jardín
            </span>
            <span className="text-2xl md:text-3xl font-bold block mt-4 text-[#f97316] bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full inline-block">
              en Torrox y la Axarquía
            </span>
          </h1>
          
          <p className="text-2xl md:text-3xl font-semibold text-white max-w-3xl mx-auto leading-relaxed bg-[#f97316]/20 backdrop-blur-sm px-6 py-4 rounded-2xl border border-white/20">
            Repuestos, revisiones y reparaciones rápidas para que tu equipo nunca se detenga
          </p>

          <div className="flex justify-center items-center pt-8">
            <Button 
              onClick={handleWhatsApp}
              variant="outline"
              size="lg"
              className="border-2 border-white text-white hover:bg-white hover:text-[#004534] px-8 py-4 text-lg font-semibold rounded-full transition-all duration-300 transform hover:scale-105 shadow-lg"
            >
              <MessageCircle className="h-5 w-5 mr-2" />
              Contactar por WhatsApp
            </Button>
          </div>


        </div>
      </div>

      {/* Scroll indicator */}
      <button
        onClick={() => {
          const element = document.getElementById('nosotros');
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce cursor-pointer hover:scale-110 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50"
        title="Ir a Quiénes Somos"
      >
        <div className="w-6 h-10 border-2 border-white rounded-full flex justify-center hover:border-[#f97316] transition-colors">
          <div className="w-1 h-3 bg-white rounded-full mt-2 animate-pulse hover:bg-[#f97316] transition-colors"></div>
        </div>
      </button>
    </section>
  );
};